class AddressDto {

    public addressLine1: string;

    public addressLine2: string;

    public addressLine3: string;

    public city: string;

    public companyName: string;

    public id: string;

    public postcode: string;

    public lat: number;
				
    public lon: number;

    public uniqueReference: string;

    public region: string;

    public county: string;

    public country: string;

    public countryCode: string;
}

export { AddressDto };